/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { splitSensorRequestMessage } from '@/lib/sensors/presentation/sensorRequestMessages';

interface SensorRequestMessageProps {
    message: string;
}

function SensorRequestMessage({ message }: SensorRequestMessageProps) {
    return (
        <>
            {splitSensorRequestMessage(message).map((part, index) => (
                part.isSensor ? (
                    <code key={`${part.value}-${index}`} className="break-all font-mono text-[0.95em]">
                        {part.value}
                    </code>
                ) : (
                    <span key={`${part.value}-${index}`}>{part.value}</span>
                )
            ))}
        </>
    );
}

export default SensorRequestMessage;
